module.exports = __webpack_public_path__ + "d44a4dbbf5d3e9298339214cb68c97a9.gif";